// import React from "react";
// import PropTypes from "prop-types";
// import { ArrowUpRight } from "lucide-react";

// export default function ImageInfo({
//   title,
//   items = [],
//   loading,
//   emptyText = "Nothing to show yet.",
// }) {
//   if (loading) {
//     return (
//       <div className="card-soft p-4 icon-list-card">
//         <div className="skeleton w-100 h-100" />
//       </div>
//     );
//   }
//   console.log(items);

//   return (
//     <div className="card-soft p-4 icon-list-card">
//       <h6 className="fw-bold mb-3">{title}</h6>

//       {items.length === 0 && (
//         <p className="text-muted mb-0" style={{ fontSize: 13 }}>
//           {emptyText}
//         </p>
//       )}
//       <div
//         className="d-flex flex-column justify-content-between"
//         style={{ height: "90%" }}
//       >
//         {items.map((item) => (
//           <div
//             key={item.id}
//             className="d-flex align-items-center gap-3 mb-3 icon-list-row "
//           >
//             <img
//               src={item.ImageUrl}
//               alt="img"
//               className=""
//               style={{
//                 width: "150px",
//                 borderRadius: "8px",
//                 objectFit: "cover",
//                 flexShrink: 0,
//                 background: "#f1f1f1",
//               }}
//             />
//             <div className="flex-grow-1">
//               <p
//                 className="fw-semibold text-dark mb-0"
//                 style={{ fontSize: 13.5 }}
//               >
//                 {item.title}
//               </p>
//               {item.description && (
//                 <p className="text-muted mb-0" style={{ fontSize: 12 }}>
//                   {item.description}
//                 </p>
//               )}
//             </div>
//             <ArrowUpRight size={16} className="text-muted flex-shrink-0" />
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

// ImageInfo.propTypes = {
//   title: PropTypes.string.isRequired,
//   items: PropTypes.arrayOf(
//     PropTypes.shape({
//       id: PropTypes.string,
//       image: PropTypes.string,
//       title: PropTypes.string,
//       description: PropTypes.string,
//       link: PropTypes.string,
//     }),
//   ),
//   loading: PropTypes.bool,
//   emptyText: PropTypes.string,
// };

import React from "react";
import ProfileCardCarousel from "./ProfileCardCarousel";

export default function ImageInfo(props) {
  return <ProfileCardCarousel {...props} />;
}
